import { loadImageDom } from './fs/image.utils';

export const calculateBarWidth = async (imgBase64: string) => {
  const imgDom = await loadImageDom(imgBase64);
  if (!imgDom) return;

  const canvas = document.createElement('canvas');
  const imgContext = canvas.getContext('2d');
  const { width, height } = imgDom;
  canvas.width = width;
  canvas.height = height;
  imgContext?.drawImage(imgDom, 0, 0);

  let minR, maxR, minAngle, maxAngle: undefined | number;
  const R = height / 2;

  const imgData = imgContext?.getImageData(0, 0, width, height);
  const data = imgData?.data ?? [];

  // 逐行逐列计算每个像素点距离圆心的距离
  for (let i = 1; i <= height; i++) {
    for (let j = 1; j <= width; j++) {
      const index = i * (width * 4) + j * 4;
      // const indexNext = i * (width * 4) + (j + 1) * 4;
      // const indexPre = i * (width * 4) + (j - 1) * 4;
      // const r = data[index],
      //   g = data[index + 1],
      //   b = data[index + 2];
      const alpha = data[index + 3];
      // 记录第一个非透明像素
      if (!alpha) continue;

      // 到圆心的距离
      const offsetX = j - width / 2;
      const offsetY = i - height / 2;
      const _r = Math.sqrt(Math.pow(offsetX, 2) + Math.pow(offsetY, 2));
      minR = minR == undefined ? _r : Math.min(_r, minR);
      maxR = maxR == undefined ? _r : Math.max(_r, maxR);

      const sin = offsetX / R;
      const cos = offsetY / R;
      let angle = Math.abs((Math.asin(sin ?? 0) * 180) / Math.PI);
      if (sin >= 0 && cos >= 0) {
        // 在第一象限
        angle = Math.abs(angle);
      } else if (sin >= 0 && cos < 0) {
        // 在第二象限
        angle = 180 - angle;
      } else if (sin <= 0 && cos < 0) {
        // 在第三象限
        angle = 180 + angle;
      } else {
        // 在第四象限
        angle = 360 - angle;
      }

      // if (angle == 90) {
      //   // console.log('angle1', r, g, b, alpha);
      //   console.log('第', i, '行', '第', j, '列，', offsetX, offsetY);
      // }

      minAngle = minAngle == undefined ? angle : Math.min(angle, minAngle);
      maxAngle = maxAngle == undefined ? angle : Math.max(angle, maxAngle);
    }
  }

  const _width = minR != undefined && maxR != undefined ? maxR - minR : 0;
  console.log('圆环的宽度为：', _width);
  console.log('圆环的角度', minAngle, maxAngle);
  return {
    width: _width,
    angleStart: minAngle,
    angleEnd: maxAngle
  };
};
